(function () {
  'use strict';
  if (window.PMGarageRecovery) return;
  var key = 'pm_garage_recovery_requests_v1';
  var outbox = [], flushing = false, retryTimer;
  // Old client failures were not verified by the recovery worker. They must
  // never be replayed as emails after this migration.
  try { localStorage.removeItem('pm_reg_failure_outbox_v1'); } catch (error) {}
  function aborted(signal) {
    if (signal && signal.aborted) throw signal.reason || new DOMException('Aborted', 'AbortError');
  }
  function delay(ms, signal) {
    return new Promise(function (resolve, reject) {
      var timer;
      function cancel() { clearTimeout(timer); cleanup(); reject(signal.reason || new DOMException('Aborted', 'AbortError')); }
      function cleanup() { if (signal) signal.removeEventListener('abort', cancel); }
      if (signal && signal.aborted) { cancel(); return; }
      timer = setTimeout(function () { cleanup(); resolve(); }, ms);
      if (signal) signal.addEventListener('abort', cancel, {once:true});
    });
  }
  async function limited(request, signal, ms) {
    var controller = new AbortController();
    function cancel() { controller.abort(signal.reason); }
    aborted(signal);
    if (signal) signal.addEventListener('abort', cancel, {once:true});
    var timer = setTimeout(function () { controller.abort(new DOMException('Lookup timed out', 'TimeoutError')); }, ms);
    try { return await request(controller.signal); }
    finally { clearTimeout(timer); if (signal) signal.removeEventListener('abort', cancel); }
  }
  async function lookup(request, options) {
    options = options || {};
    var signal = options.signal, lastPending = null, transportFailures = 0;
    var until = Date.now() + Math.max(1, Math.min(90000, Number(options.maxWaitMs) || 90000));
    while (true) {
      aborted(signal);
      var remaining = until - Date.now();
      if (remaining <= 0 && lastPending) return lastPending;
      var data;
      try {
        data = await limited(request, signal, Math.max(1, Math.min(15000, remaining)));
        aborted(signal);
        transportFailures = 0;
      } catch (error) {
        aborted(signal);
        var status = Number(error && (error.status || error.httpStatus)) || 0;
        if (status >= 400 && status < 500 && status !== 429) throw error;
        transportFailures++;
        if (until - Date.now() <= 0 || transportFailures >= 3) {
          if (lastPending) return lastPending;
          throw error;
        }
        await delay(Math.min(1500 * transportFailures, until - Date.now()), signal);
        continue;
      }
      if (!data || data.recovery_status !== 'pending') return data;
      lastPending = data;
      if (typeof options.onPending === 'function') options.onPending(data);
      if (until - Date.now() <= 0) return data;
      var wait = Math.max(1000, Math.min(5000, Number(data.retry_after || 2) * 1000));
      await delay(Math.min(wait, until - Date.now()), signal);
    }
  }
  function reason(data, fallback) {
    if (data && data.recovery_admitted === false) return 'unavailable';
    if (data && (data.unsupported_vehicle === true || data.recovery_status === 'unsupported')) return 'unsupported';
    if (data && (data.registration_not_found === true || data.recovery_status === 'not_found')) return 'not_found';
    if (data && data.recovery_status === 'pending') return 'pending';
    if (data && data.recovery_status === 'provider_unavailable') return 'unavailable';
    return fallback || 'no_match';
  }
  function save() {
    var now = Date.now();
    outbox = outbox.filter(function (item) { return item && ['reg','vin'].includes(item.kind)
      && typeof item.value === 'string' && /^[A-Z0-9]{2,17}$/.test(item.value)
      && item.created > now - 86400000 && item.attempts < 8; }).slice(-20);
    try { localStorage.setItem(key, JSON.stringify(outbox)); } catch (error) {}
  }
  try { var stored = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(stored)) outbox = stored; } catch (error) {}
  function schedule() {
    clearTimeout(retryTimer);
    if (!outbox.length || flushing) return;
    retryTimer = setTimeout(flush, Math.max(500, Math.min.apply(null, outbox.map(function (item) { return item.next || 0; })) - Date.now()));
  }
  async function flush() {
    if (flushing) return;
    save();
    var item = outbox.find(function (entry) { return !entry.next || entry.next <= Date.now(); });
    if (!item) { schedule(); return; }
    flushing = true;
    try {
      var reply = await limited(async function (signal) {
        var response = await fetch('/apps/pm-garage/' + (item.kind === 'vin' ? 'vin' : 'reg') + '-lookup?'
          + new URLSearchParams(item.kind === 'vin' ? {vin:item.value,recovery:1} : {reg:item.value,recovery:1}),
          {credentials:'same-origin',headers:{Accept:'application/json'},signal:signal});
        return {ok:response.ok,data:await response.json()};
      }, null, 12000);
      var data = reply.data;
      if (!reply.ok || !data || data.recovery_admitted === false || (!data.recovery_status && !((data.vehicles || []).length || (data.candidate_vehicles || []).length))) {
        throw new Error('Recovery request not acknowledged');
      }
      outbox = outbox.filter(function (entry) { return entry !== item; });
    } catch (error) {
      item.attempts = (Number(item.attempts) || 0) + 1;
      item.next = Date.now() + Math.min(3600000, 30000 * Math.pow(2, item.attempts - 1));
    } finally { flushing = false; save(); schedule(); }
  }
  function fail(detail) {
    detail = detail || {};
    if (detail.unsupported_vehicle === true || detail.recovery_status ||
        !['http_error','network_error','invalid_response'].includes(detail.reason)) return;
    var kind = detail.kind === 'vin' ? 'vin' : 'reg';
    var value = String(kind === 'vin' ? detail.vin || detail.chassis_number || '' : detail.registration_number || '')
      .toUpperCase().replace(/[\s-]/g, '');
    if (!(kind === 'reg' ? /^[A-Z]{3}[0-9]{2}[A-Z0-9]$/ : /^[A-Z0-9]{4,17}$/).test(value)) return;
    save();
    if (!outbox.some(function (item) { return item.kind === kind && item.value === value; })) {
      outbox.push({kind:kind,value:value,created:Date.now(),attempts:0,next:0});
      save();
    }
    flush();
  }
  window.PMGarageRecovery = {lookup:lookup, reason:reason};
  // Compatibility API now requests server recovery. It never sends mail.
  window.PMRegLookupAlerts = {fail:fail};
  var early = Array.isArray(window.PMRegLookupAlertQueue) ? window.PMRegLookupAlertQueue.splice(0,10) : [];
  early.forEach(fail);
  window.addEventListener('online', function () { outbox.forEach(function (item) { item.next = 0; }); flush(); });
  window.addEventListener('pageshow', flush);
  save(); flush();
})();
